import { useStaticQuery, graphql } from "gatsby"
import * as React from "react"
import Link from "../components/Link/Link"

export default function Header() {

  const { wp } = useStaticQuery(
    graphql`
            query {
                wp {
                    generalSettings {
                        title
                    }
                }
            }
        `
  )

  const triggerGlobalMenu = () => {
    const element = document.getElementById("ubc7-global-menu");
    element.classList.toggle("in");
  }

  return (
    <>
      <a className="skip-link" href="#main">Skip to main content</a>
      <div className="collapse expand" id="ubc7-global-menu">
        <div id="ubc7-search" className="expand">
          <div id="ubc7-search-box">
            <form className="form-search" method="get" action="https://www.ubc.ca/search/refine/" role="search">
              <input aria-label="Search this website" type="text" name="q" placeholder="Search this website" className="input-xlarge search-query" />
              <input aria-hidden="true" type="hidden" name="label" value="Search beyond.ubc.ca" />
              <input aria-hidden="true" type="hidden" name="site" value="beyond.ubc.ca" />
              <button type="submit" className="btn">Search</button>
            </form>
          </div>
        </div>
        <div className="container">
          <div id="ubc7-global-header" className="expand">
            <div className="row-fluid">
              <div className="span8 offset2">
                <ul className="reverse">
                  <li><a href="https://www.calendar.ubc.ca/">Academic Calendar</a></li>
                  <li><a href="https://www.ubc.ca/landing/campusservices.html">Campus Services</a></li>
                  <li><a href="https://www.ubc.ca/landing/facultiesschools.html">Faculties &amp; Schools</a></li>
                  <li><a href="https://www.library.ubc.ca/">Library</a></li>
                  <li><a href="https://www.ubc.ca/about/maps.html">Maps</a></li>
                  <li><a href="https://www.ubc.ca/quicklinks/">Quicklinks</a></li>
                  <li><a href="https://ssc.adm.ubc.ca/sscportal/">Student Service Centre</a></li>
                  <li><a href="https://directory.ubc.ca/index.cfm">UBC Directory</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <header id="ubc7-header" className="row-fluid expand" role="banner">
        <div className="container">
          <div className="span1">
            <div id="ubc7-logo">
              <a href="https://www.ubc.ca" title="The University of British Columbia (UBC)">The University of British Columbia</a>
            </div>
          </div>
          <div className="span2" />
          <div className="span9" id="ubc7-wordmark-block">
            <div id="ubc7-wordmark">
              <a href="https://www.ubc.ca" title="The University of British Columbia (UBC)">The University of British Columbia</a>
            </div>
            <div id="ubc7-global-utility">
              <button type="button" onClick={triggerGlobalMenu} data-toggle="collapse" data-target="#ubc7-global-menu"><span>UBC Search</span></button>
              <noscript><a id="ubc7-global-utility-no-script" href="https://www.ubc.ca/" title="UBC Search">UBC Search</a></noscript>
            </div>
          </div>
        </div>
      </header>
      <div id="ubc7-unit" className="row-fluid expand">
        <div className="container">
          <div className="span12">
            <div id="ubc7-unit-name" className="ubc7-single-element">
              <Link
                to="/"
              >
                <span id="ubc7-unit-identifier">{wp.generalSettings.title}</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
